<script>
import MineTitle from '../../components/mineTitle.vue';

export default {
    name: "dashboard",
    data() {
        return {};
    },
    computed: {},
    components: {
        MineTitle
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="dashboard">
        <MineTitle name="Dashboard" page="Mine / Dashboard"/>
        <div class="wrapper flex">
            <div class="content flex justify_between">
                <div class="text flex flex_column justify_center">
                    <div class="name">Enrolled Courses</div>
                    <div class="num">1</div>
                </div>
                <div class="layout_bg icon icon01"></div>
            </div>
            <div class="content flex justify_between">
                <div class="text flex flex_column justify_center">
                    <div class="name">In Wishlist</div>
                    <div class="num">0</div>
                </div>
                <div class="layout_bg icon icon02"></div>
            </div>
            <div class="content flex justify_between">
                <div class="text flex flex_column justify_center">
                    <p class="name">Purchases</p>
                    <p class="num">1</p>
                </div>
                <div class="layout_bg icon icon03"></div>
            </div>
        </div>
        <div class="wrapper flex">
            <div class="content">
                <div class="text">
                    <p class="log">Please Upload Documents !!!</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    gap: 1.64rem;
    margin-bottom: .4rem;
    &:last-child{
        margin-bottom: 0;
    }
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: .4rem;
        margin-bottom: .8rem;
        &:last-child{
            margin-bottom: 0;
        }
    }
    .content{
        width: 3.54rem;
        background: #fff;
        border-radius: .05rem;
        padding: .15rem;
        padding-left: .25rem;
        @media only screen and (max-width: 750px) {
            width: auto;
        }
        .log{
            font-size: .16rem;
            color: #999;
            padding: .15rem 0;
        }
        .name{
            font-size: .2rem;
            color: #999;
            margin-bottom: .3rem;
            @media only screen and (max-width: 750px) {
                font-size: .24rem;
            }
        }
        .num{
            font-size: .48rem;
        }
        .icon{
            width: 1.3rem;
            height: 1.7rem;
            background-size: 1rem auto;
            border-radius: .05rem;
            &.icon01{
                background-image: url('~@/assets/images/dashboard_icon_01.png');
                background-color: #87c1aa;
            }
            &.icon02{
                background-image: url('~@/assets/images/dashboard_icon_02.png');
                background-color: #f4ce69;
            }
            &.icon03{
                background-image: url('~@/assets/images/dashboard_icon_03.png');
                background-color: #3271ae;
            }
        }
    }
}
</style>